function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomError = /*#__PURE__*/function (_Error) {
  function CustomError(originalError) {
    var _originalError$stack;
    var _this;
    var isOrigErrorValid = originalError instanceof Error;
    var prevStackLines = isOrigErrorValid ? (_originalError$stack = originalError.stack) == null ? void 0 : _originalError$stack.split('\n') : [];
    _this = _Error.call(this, isOrigErrorValid ? originalError.name + ": " + originalError.message : '') || this;
    _this.originalError = void 0;
    _this.name = _this.constructor.name;
    if (isOrigErrorValid) {
      _this.originalError = originalError;
    }
    if (prevStackLines != null && prevStackLines.length && _this.stack) {
      _this.stack = _this.stack.split('\n').slice(0, 2).concat(prevStackLines.slice(1, prevStackLines.length)).join('\n');
    }
    return _this;
  }
  _inheritsLoose(CustomError, _Error);
  return CustomError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var PersistError = /*#__PURE__*/function (_CustomError2) {
  function PersistError() {
    return _CustomError2.apply(this, arguments) || this;
  }
  _inheritsLoose(PersistError, _CustomError2);
  return PersistError;
}(CustomError);
export var RehydrateError = /*#__PURE__*/function (_CustomError3) {
  function RehydrateError() {
    return _CustomError3.apply(this, arguments) || this;
  }
  _inheritsLoose(RehydrateError, _CustomError3);
  return RehydrateError;
}(CustomError);
export var MigrateError = /*#__PURE__*/function (_CustomError4) {
  function MigrateError() {
    return _CustomError4.apply(this, arguments) || this;
  }
  _inheritsLoose(MigrateError, _CustomError4);
  return MigrateError;
}(CustomError);
//# sourceMappingURL=errors.mjs.map